"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArgumentTemplate = void 0;
const Models_1 = require("../../Models/index");
const TemplateUtils_1 = require("./TemplateUtils");
class ArgumentTemplate {
    static resolve({ args, type }, prefix = 0) {
        var _a;
        let argsString = '';
        if (args) {
            const isArray = (_a = type.options) === null || _a === void 0 ? void 0 : _a.includes(Models_1.Options.array);
            if (args.length) {
                if (type.options && isArray) {
                    argsString = `[${args.map((a) => TemplateUtils_1.TemplateUtils.resolverForConnection(a, prefix)).join(',\n')}]`;
                }
                else {
                    argsString = `${args.map((a) => TemplateUtils_1.TemplateUtils.resolverForConnection(a, prefix)).join('\n')}`;
                }
            }
            else {
                if (isArray) {
                    argsString = '[]';
                }
            }
        }
        return `${type.name}: ${argsString}`;
    }
}
exports.ArgumentTemplate = ArgumentTemplate;
